// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__X5AJ-","icon":"Button_icon__KeIH3","title":"Button_title__tvMyU"};